import {
  getTableData,
  getSubData,
  getDetail,
  addWebinar,
  updateWebinar,
  getConcept,
  changeStatus,
  saveSample,
  getSampleRequestTotal,
  exportSample,
  del
} from '@/axios/api/webinar'
import {
  getTrend,
  getConceptList,
  getEventList
} from '@/axios/api/appPictures'
import { Message } from 'element-ui'
import {getDictionary} from "@/axios/api/dictionary";

const UPDATE_TABLEDATA = 'UPDATE_TABLEDATA'
const UPDATE_TBL_LOADING = 'UPDATE_TBL_LOADING'
const UPDATE_VIEW_LOADING = 'UPDATE_VIEW_LOADING'
const UPDATE_TOTAL = 'UPDATE_TOTAL'
const UPDATE_SUB_LIST = 'UPDATE_SUB_LIST'
const UPDATE_OPTIONS = 'UPDATE_OPTIONS'
const UPDATE_DETAIL = 'UPDATE_DETAIL'

const state = {
  tableData: [],
  tblLoading: false,
  viewLoading: false,
  detailLoading: false,
  filter: {
    id: '',
    title: '',
    countryId: '',
    segment: '',
    speaker: '',
    createBy: '',
    date: [],
    startTime: '',
    endTime: ''
  },
  options: {
    country: [],
    segment: []
  },
  pager: {
    current: 1,
    size: 10,
    total: 0
  },
  subList: [],
  detail: {}
}
const getters = {
  tableData: state => state.tableData,
  pager: state => state.pager,
  tblLoading: state => state.tblLoading,
  viewLoading: state => state.viewLoading,
  detailLoading: state => state.detailLoading,
  subList: state => state.subList,
  detail: state => state.detail,
  options: state => state.options,
  filter: state => state.filter
}
const mutations = {
  [UPDATE_TABLEDATA] (state, tableData) {
    state.tableData = tableData
  },
  [UPDATE_TBL_LOADING] (state, tblLoading) {
    state.tblLoading = tblLoading
  },
  [UPDATE_DETAIL] (state, detail) {
    state.detail = detail
  },
  [UPDATE_VIEW_LOADING] (state, viewLoading) {
    state.viewLoading = viewLoading
  },
  [UPDATE_TOTAL] (state, total) {
    state.pager = { ...state.pager, total }
  },
  [UPDATE_SUB_LIST] (state, subList) {
    state.subList = subList
  },
  [UPDATE_OPTIONS] (state, {key, value}) {
    state.options[key] = value
  }
}
const actions = {
  async initOptions({commit}){
    try {
      let {data: res} = await getDictionary(134)
      commit(UPDATE_OPTIONS, {key: 'country', value: res || []})
    }
    catch (e) {
      // Message.error(e)
    }
    try {
      let {data: res} = await getDictionary(274)
      commit(UPDATE_OPTIONS, {key: 'segment', value: res || []})
    }catch (e) {
      // Message.error(e)
    }
  },
  async getTableDataApi ({commit, state}) {
    commit(UPDATE_TBL_LOADING, true)
    try {
      let { current, size } = state.pager
      const start = state.filter.date ? state.filter.date[0] : ''
      const startDate = start ? new Date(start).getTime() / 1000 : ''
      const end = state.filter.date ? state.filter.date[1] : ''
      const addTime = (23 * 60 + 59) * 60 + 59 // 结束时间补23:59:59
      const endDate = end ? new Date(end).getTime() / 1000 + addTime : ''
      const params = {
        ...state.filter,
        date: undefined,
        current,
        size,
        startDate,
        endDate,
        desc: ['create_date']
      }
      let { data: res } = await getTableData(params)
      commit(UPDATE_TABLEDATA, res.records)
      commit(UPDATE_TOTAL, res.total)
    } catch (e) {
      // Message.error(e)
    }
    commit(UPDATE_TBL_LOADING, false)
  },
  async getDetailApi ({commit, state},params) {
    try {
      let { data: res, errorCode } = await getDetail({id: params})
      commit(UPDATE_DETAIL, res)
      return errorCode
    } catch (e) {
      Message.error(e)
    }
    commit(UPDATE_TBL_LOADING, false)
  },
  async addWebinarApi ({ commit }, params) {
    try {
      let { data: res, errorCode } = await addWebinar(params)
      return errorCode
    } catch (e) {
      Message.error(e)
    }
  },
  async updateWebinarApi ({ commit }, params) {
    try {
      let { data: res, errorCode } = await updateWebinar(params)
      return errorCode
    } catch (e) {
      Message.error(e)
    }
  },
  async getConcept ({ commit }, params) {
    try {
      let { data: res } = await getConcept({keyword: params})
      return res || []
    } catch(e){
      Message.error(e)
    }
  },
  setViewLoadingApi ({ commit }, params) {
    commit(UPDATE_VIEW_LOADING, params)
  },
  async getSubListApi ({ commit }, payload) {
    commit(UPDATE_VIEW_LOADING, true)
    try {
      let { data: res } = await getSubData({
        ...payload,
        desc: ['id']
      })
      commit(UPDATE_SUB_LIST, res.records)
      return res.total
    } catch (e) {
      Message.error(e)
    }
    commit(UPDATE_VIEW_LOADING, false)
  },
  async changeStatusApi ({ commit }, params) {
    try {
      await changeStatus(params)
      Message.success('success')
      return true
    } catch (e) {
      Message.success('failed')
      return false
    }
  },
  async saveSampleApi ({ commit }, params) {
    try {
      const res = await saveSample(params)
      return res.errorCode === 200
    } catch (e) {
      return false
    }
  },
  async getSampleRequestTotalApi (content, payload) {
    try {
      const { data: res } = await getSampleRequestTotal(payload)
      return res || 0
    } catch (error) {
      return 0
    }
  },
  // 获取各个模块二级下拉列表
  async getPageListApi ({commit}, { moduleId, keyword }) {
    try {
      const res = await getPageListFn[moduleId]({keyword})
      return res || []
    } catch (e) {
      return false
    }
  },
  // 删除
  async delApi ({ commit }, params) {
    try {
      const res = await del(params)
      return res && res.errorCode === 200
    } catch (e) {}
  }
}
const getPageListFn = {
  696: async function (params) {
    try {
      const { data } = await getTrend({
        ...params,
        size: 10
      })
      return data.map(value => {
        return {
          value: value.id,
          label: value.title
        }
      })
    } catch (e) {
      return []
    }
  },
  695: async function (params) {
    try {
      const { data } = await getConceptList({
        ...params,
        size: 10
      })
      return data.map(value => {
        return {
          value: value.id,
          label: value.internationalTitle
        }
      })
    } catch (e) {
      return []
    }
  },
  697: async function (params) {
    try {
      const { data } = await getEventList({
        ...params,
        size: 10
      })
      return data.map(value => {
        return {
          value: value.id,
          label: value.eventName
        }
      })
    } catch (e) {
      return []
    }
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/webinar.js